import { Button } from 'antd';
import { CalendarPlus } from 'lucide-react';

export function AddPeriodButton({ isFirst, onClick }: { isFirst: boolean; onClick: () => void }) {
  return (
    <Button type="primary" icon={<CalendarPlus className="size-4" />} onClick={onClick}>
      {isFirst ? 'Add first period' : 'Add next period'}
    </Button>
  );
}
